import React from 'react'
import { Upload, Form } from 'antd'
import type { UploadProps } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { InboxOutlined } from '@ant-design/icons'
import type { UploadChangeParam } from 'antd/lib/upload'
import type { UploadFile } from 'antd/lib/upload/interface'
import { getCalculateFootprintSelector } from 'src/features'
import { showNotification, validateCabifyCSVFile } from 'src/core/helpers'

const ImportCabifyFile: React.FC = () => {
  const { t } = useTranslation()
  const { loading: loadingCalculate } = useAppSelector(getCalculateFootprintSelector)

  const handleBeforeUpload = async (file: File) => {
    const isValid = await validateCabifyCSVFile(file)
    if (isValid) {
      showNotification('success', t('admin.MassiveCalculate.FileUploadSuccess'))
    }
    return !isValid
  }

  const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
    const { status } = info.file
    switch (status) {
      case 'error':
        info.file.response = 'Upload Error'
        showNotification('error', t('admin.MassiveCalculate.FileUploadError'))
        break
      case 'removed':
        showNotification('success', t('admin.MassiveCalculate.FileUploadRemoved'))
        break
      default:
        break
    }
  }

  const uploadProps: UploadProps = {
    name: 'cabifyFile',
    multiple: false,
    beforeUpload: handleBeforeUpload,
    onChange: handleChange,
    accept: '.csv, .zip, .rar',
    maxCount: 1,
    disabled: loadingCalculate
  }

  return (
    <Form.Item
      name='cabifyFile'
      rules={[{ required: true, message: t('general.RequiredValidation') }]}
    >
      <Upload.Dragger {...uploadProps}>
        <p className='ant-upload-drag-icon'>
          <InboxOutlined />
        </p>
        <p className='ant-upload-text'>{t('admin.MassiveCalculate.UploadText')}</p>
        <p className='ant-upload-hint'>{t('Cabify.FileAllowed')}</p>
      </Upload.Dragger>
    </Form.Item>
  )
}

export default ImportCabifyFile
